import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleTrova() {
  return <ArticleLayout article={articleContents['trova-prodotti-itaobuy']} />;
}